import styled from 'styled-components'
import { ZingTheme } from '../../../../assets/theme/types'

const DIVIDER_COLOR = 'rgba(255, 255, 255, 0.2)'

export const FooterWrapper = styled.footer`
  width: 100%;
  height: 13rem;
  background-color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const FooterLinksWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const SocialList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
`

export const SocialItem = styled.li`
  margin: 0 0.75rem;
`

export const FooterHr = styled.hr`
  width: 100%;
  margin: 0.55rem 0;
  border-color: ${DIVIDER_COLOR};
`

export const FooterEmail = styled.p`
  font-size: 0.75rem;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
  margin-bottom: 0.5rem;
`

export const FooterCopyright = styled.p`
  font-size: 0.75rem;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
`
